import { isBoolean as s } from "./is.js";
const f = (o, t = o) => s(o) ? o : !!t, e = (o) => o === !0, l = (o) => o !== !1, n = (o) => !1, c = (o) => !0;
export {
  e as boolOrFalse,
  l as boolOrTrue,
  f as boolify,
  n as falsify,
  c as truthify
};
